import React, { Component } from 'react';
import { connect } from 'react-redux'
import Grid from '../grid/Grid'
//import DeleteButton from '../grid/DeleteButton'
import { deleteNitratiVirszemes, reloadNitratiVirszemes, loadNitratiVirszemes } from '../../actions/nitratiActions'
import {
    getTextFilterCfg,
    //getDateFilterCfg,
    //getBadgeFormatterForKodif,
    //getSelectFilterCfg,
} from '../grid/ColumnHelpers'
import Form from '../forms/Form'
//import * as constants from '../../constants'
//import { isEmptyValue } from '../forms/FormHelpers'
import {saveAtskaite, goToAtskaites} from '../../actions/atskaiteActions'
//import { getFileHref, fileDownloadPath } from '../forms/FormHelpers'
import { Button,
    Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap";
import { guiSet } from '../../actions/uiActions';
import { useEffect } from 'react';

const getColumns = ({ kodif }) => {
    return [
        {
            dataField: 'ND_NatStatCode',
            text: 'ND_NatStatCode',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_NatStatName',
            text: 'ND_NatStatName',
            renderClassName: "bold",
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'WaterBodyID',
            text: 'WaterBodyID',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'WaterBodyName',
            text: 'WaterBodyName',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'ND_WatEntName',
            text: 'ND_WatEntName',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'Latitude',
            text: 'Latitude',
            filterCfg: getTextFilterCfg()
        },
        {
            dataField: 'Longitude',
            text: 'Longitude',
            filterCfg: getTextFilterCfg()
        },
    ]
};

const atskaiteFrmFieldCfgs = ({ values = {}, setFieldValue, fetchAct, selectedItem, kodif } = {}) => {
  const periods_garums = 4;
  const baseYear = 2016;

  const currentYear = new Date().getFullYear();

  const defaultValue =
    values.gads_periods ||
    selectedItem?.periods ||
    (() => {
      const start = baseYear + Math.floor((currentYear - baseYear) / periods_garums) * periods_garums;
      return `${start}-${start + periods_garums - 1}`;
    })();

  const PeriodSelector = (props) => {
    const { currentVal, setFieldValue } = props;
    const selectedValue = currentVal || defaultValue;

    useEffect(() => {
      if (!currentVal && setFieldValue) {
        setFieldValue('gads_periods', defaultValue);
      }
    }, [currentVal, setFieldValue]);

    const parsePeriod = (period) => {
      const [start] = period.split('-').map(Number);
      return start;
    };

    const formatPeriod = (start) => `${start}-${start + periods_garums - 1}`;

    const updateValue = (val) => {
      if (setFieldValue) setFieldValue('gads_periods', val);
      if (fetchAct && selectedItem) fetchAct({ ...selectedItem, periods: val });
    };

    const nextYear = () => formatPeriod(parsePeriod(selectedValue) + periods_garums);
    const prevYear = () => formatPeriod(parsePeriod(selectedValue) - periods_garums);

    return (
      <div className="d-flex align-items-center justify-content-center mt-2">
        <i
          className="fa fa-caret-left"
          title={prevYear()}
          onClick={() => updateValue(prevYear())}
        />
        <span className="mx-4">{selectedValue}</span>
        <i
          className="fa fa-caret-right"
          title={nextYear()}
          onClick={() => updateValue(nextYear())}
        />
      </div>
    );
  };

  return [
    {
      name: 'gads_periods',
      label: 'Gadu periodi',
      defaultValue,
      customField: PeriodSelector
    }
  ];
};


class NitratiVirszemes extends Component {
    componentDidMount() {
        // Start polling when the component mounts
        this.pollingInterval = setInterval(this.checkForUzsaktaStatus, 5000); // Check every 5 seconds
    }

    componentWillUnmount() {
        // Clear the interval when the component unmounts
        clearInterval(this.pollingInterval);
    }
    constructor(props) {
      super(props);
      this.state = {
        modalSearch: false,
        exportPopup: false,
        goToAtskaitePopup: false,
      };
    }

    openModalExport = (type) => {
      this.setState({
        exportPopup: true,
        goToAtskaitePopup: false,
        exportType: type,
        atskaite: {
          kods: type,
          gads_no: null,
          gads_līdz: null,
          gads_periods: ''
        }
      });
    };

    closeModalExport = () => {
      this.setState({
        exportPopup: false,
        goToAtskaitePopup: false,
      });
    };

    toggleModalSearch = () => {
      this.setState({
        modalSearch: !this.state.modalSearch
      });
    }

    toggleGoToAtskaitePopup = () => {
      this.setState({
        goToAtskaitePopup: !this.state.goToAtskaitePopup
      });
    }

    setDateField = (fieldName, value) => {
      this.setState({
        atskaite: {
          ...this.state.atskaite,
          [fieldName]: value
        }
      });
    }

    render() {
        //const atskaiteRole = this.props.user && this.props.user.tiesibas.includes('NITRATI_LABOT')
        const { loading, list, count } = this.props.nitratiVirszemes

        if (!this.columns) {
            this.columns = getColumns({
                kodif: this.props.kodif
            })
        }

        if(!this.atskaiteFields){
          this.atskaiteFields = atskaiteFrmFieldCfgs({
            kodif: this.props.kodif,
            setDateField: this.setDateField
          })
        }

        return (
            <>
                <Modal isOpen={this.state.goToAtskaitePopup} className="modal-lg">
                  <ModalHeader>Atskaite</ModalHeader>
                  <ModalBody>
                    Atskaites veidošana uzsākta!
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" onClick={this.props.goToAtskaites}>Iet uz atskaišu sarakstu</Button>
                    <Button color="secondary" onClick={this.toggleGoToAtskaitePopup}>Aizvērt</Button>
                  </ModalFooter>
                </Modal>

                <div className="saraksts-wrapper">
                    <Grid
                        loading={loading}
                        dataList={list}
                        totalCount={count}
                        columns={this.columns}
                        rowEvents={this.rowEvents}
                    >
                        <Button color="primary" onClick={() => this.openModalExport("Nitratu_zinojuma_tabulas")}>
                          Eksportēt uz Excel
                        </Button>
                    </Grid>
                </div>

                <Modal isOpen={this.state.exportPopup} className="modal-sm">
                  <ModalHeader>Eksportēt nitrātus</ModalHeader>
                  <ModalBody className="text-center">

                    <div className="">
                    <Form
                          onSubmit={(atskaite) => {
                            const [start, end] = atskaite.gads_periods.split('-').map(Number);
                            atskaite.gads_no = start;
                            atskaite.gads_līdz = end;
                            console.log(start, end);
                            this.props.saveAtskaite(atskaite, this.toggleGoToAtskaitePopup);
                            this.closeModalExport();
                          }}
                          tiesibasLabot="NITRATI_LABOT"
                          formFieldCfgs={this.atskaiteFields}
                          metadataFormCfg="atskaite"
                          dataObj={this.state.atskaite}
                          editable={true}
                          sizeLabel={3}
                          onReset={this.closeModalExport}
                        />
                    </div>

                  </ModalBody>
                </Modal>
            </>
        )
    }
}

const mapStateToProps = ({nitratiVirszemes, kodif, gui, location}) => ({nitratiVirszemes, kodif, gui, query: location.query})

export default connect(mapStateToProps,
    {
        guiSet,
        loadNitratiVirszemes: loadNitratiVirszemes,
        reloadNitratiVirszemes: reloadNitratiVirszemes,
        deleteAct: deleteNitratiVirszemes,
        saveAtskaite: saveAtskaite,
        goToAtskaites: goToAtskaites,
    }
)(NitratiVirszemes)
